import { inheritsWorkspaceV2Theme } from './workspaceV2';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

// Duas chaves de tema (clássica e V2) só se sustentam se a escolha de chave
// seguir a TELA. A casa dos relatórios é produto novo: herda a chave da V2
// mesmo quando o caminho não tem o prefixo `/v2` (ver inheritsWorkspaceV2Theme).
const colorSchemeKey = () =>
  typeof window !== 'undefined' &&
  inheritsWorkspaceV2Theme(window.location.pathname)
    ? `${LOCAL_STORAGE_KEYS.COLOR_SCHEME}_workspace_v2`
    : LOCAL_STORAGE_KEYS.COLOR_SCHEME;

export const COLOR_SCHEMES = ['auto', 'light', 'dark'];

// SiteUp: o sistema nasce escuro. Quem nunca escolheu tema recebe `dark`, e nao
// mais o `auto` que herdava o tema do sistema operacional. `auto` continua
// disponivel como escolha explicita em Aparencia. Valor invalido (lixo no
// storage) tambem cai neste DEFAULT, o mesmo resultado do pre-paint, que trata
// qualquer scheme !== 'light' que nao seja 'auto' como dark. Esta regra vive em
// tres copias: este helper, o script pre-paint de vueapp.html.erb e o login
// (v3/App.vue via isDarkColorScheme). Qualquer fix mexe nas tres juntas.
export const DEFAULT_COLOR_SCHEME = 'dark';

export const getColorScheme = () => {
  const raw = LocalStorage.get(colorSchemeKey());
  return COLOR_SCHEMES.includes(raw) ? raw : DEFAULT_COLOR_SCHEME;
};

export const isDarkColorScheme = isOSOnDarkMode => {
  const selectedColorScheme = getColorScheme();
  return selectedColorScheme === 'auto'
    ? isOSOnDarkMode
    : selectedColorScheme === 'dark';
};

export const setColorTheme = isOSOnDarkMode => {
  // SiteUp PWA: a classe `dark` precisa estar no <html> E no <body>.
  // O token --background-color do tema escuro vive sob `.dark`. O #589 pintou
  // html,body com esse token pra cobrir a safe area (viewport-fit=cover), mas
  // só o body ganhava a classe — o html ficava no token claro (#f7f7f7) e as
  // beiradas do iPhone apareciam brancas. O login (v3) já faz no documentElement.
  if (isDarkColorScheme(isOSOnDarkMode)) {
    document.documentElement.classList.add('dark');
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.documentElement.classList.remove('dark');
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};

export const applyColorScheme = theme => {
  const next = COLOR_SCHEMES.includes(theme) ? theme : DEFAULT_COLOR_SCHEME;
  LocalStorage.set(colorSchemeKey(), next);
  if (typeof window === 'undefined') return next;
  setColorTheme(window.matchMedia('(prefers-color-scheme: dark)').matches);
  return next;
};
